import { useState, useEffect } from 'react';
import { useFormikContext } from 'formik';
import { v4 as uuidv4 } from 'uuid';

import { DeleteDialogUI, FileTabUI, TabsUI } from '../Interface';
import SourceListOperation from './SourceListOperation';
import SourceListItem from './SourceListItem';
import sourcelistService from '../../service/sourcelist.service';
import { NotificationType } from '../../config';
import addNotification from '../../utils/addNotification';
import jokerService from '../../service/joker.service';
import { JokerTypes } from '../../config/joker';
import JokerTab from '../Interface/Joker/JokerTab';

const SourceListTabs = (props) => {
  const { values, setFieldValue } = useFormikContext();
  const { setRefetchTable, selectedValuesState, user, disabled, addField } = props;
  const { selectedValues, setSelectedValues } = selectedValuesState;
  const [activeTab, setActiveTab] = useState(0);
  const [removeElement, setRemoveElement] = useState(null);
  const [deleteDialog, setDeletDialog] = useState(false);
  const [jokerGroups, setJokerGroups] = useState([]);
  const [fileToDelete, setFileToDelete] = useState(null);

  const getJokerGroups = async () => {
    jokerService.getGroups(JokerTypes.SOURCELIST).then((data) => {
      setJokerGroups(data);
    });
  };

  useEffect(() => {
    getJokerGroups();
  }, []);

  const handleUpload = (files) => {
    const filesWithId = files.map((file) => {
      file.id = uuidv4();
      return file;
    });

    const existingAttachments = Array.isArray(values.sourceListAttachment) ? values.sourceListAttachment : [];

    setFieldValue('sourceListAttachment', [...existingAttachments, ...filesWithId]);
  };

  const handleRemoveElement = () => {
    setFieldValue(
      'sourceListAttachment',
      (values.sourceListAttachment || []).filter((sourceListAttachment) => sourceListAttachment.id !== fileToDelete.id)
    );

    setFileToDelete(null);
    hideDeleteDialog();
  };

  const hideDeleteDialog = () => {
    setDeletDialog(false);
    setRefetchTable(true);
  };

  const tabs = [
    {
      id: 0,
      name: 'Művelet',
      content: <SourceListOperation {...props} />,
    },
    {
      id: 1,
      name: 'Alapanyag',
      content: <SourceListItem {...props} />,
    },
    {
      id: 2,
      name: 'Csatolmányok',
      content: (
        <FileTabUI
          savedFiles={values?.sourceListAttachment ?? []}
          handleDelete={(file) => {
            setFileToDelete(file);
            setDeletDialog(true);
          }}
          disabled={disabled}
          handleUpload={handleUpload}
        />
      ),
    },

    ...((jokerGroups.length > 0 &&
      jokerGroups
        .filter((group) => group.jokerFields.length > 0)
        .map((group, index) => ({
          id: index + 3,
          name: group.name,
          content: <JokerTab fields={group.jokerFields} key={index} {...props} />,
        }))) ||
      []),
  ];

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  return (
    <div className="my-4 mt-6">
      <div className="px-3">
        <TabsUI activeTab={activeTab} handleTabClick={handleTabClick}>
          {tabs.map((tab, index) => (
            <div key={index} name={tab.name}>
              {tab.content}
            </div>
          ))}
        </TabsUI>
      </div>
      <DeleteDialogUI
        handleRemoveElement={handleRemoveElement}
        show={deleteDialog}
        onHide={() => {
          hideDeleteDialog();
          setFileToDelete(null);
        }}
      />
    </div>
  );
};

export default SourceListTabs;
